import { eduIDApi } from "./common";
export const loginApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchAbort: builder.query({
            query: (body) => ({
                url: "abort",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchUsernamePassword: builder.query({
            query: (body) => ({
                url: "pw_auth",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchToU: builder.query({
            query: (body) => ({
                url: "tou",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchLogout: builder.query({
            query: (body) => ({
                url: "logout",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchErrorInfo: builder.query({
            query: () => ({
                url: "error_info",
                body: {},
            }),
            extraOptions: { service: "login" },
        }),
        fetchUseOtherDevice1: builder.query({
            query: (body) => ({
                url: "use_other_1",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchUseOtherDevice2: builder.query({
            query: (body) => ({
                url: "use_other_2",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchNext: builder.query({
            query: (body) => ({
                url: "next",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchNewDevice: builder.query({
            query: (body) => ({
                url: "new_device",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        fetchMfaAuth: builder.query({
            query: (body) => ({
                url: "mfa_auth",
                body,
            }),
            extraOptions: { service: "login" },
        }),
        signupAuthn: builder.query({
            query: (body) => ({
                url: "signup_auth",
                body: {
                    ref: body.ref,
                },
            }),
            extraOptions: { service: "login" },
        }),
    }),
});
